import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Stack, Button, Typography } from "@mui/material";
import ProgressDialog from "../../component/ProgressDialog";
import { isEmpty } from "../../services/validation";
import { Toast } from "../../component/Toast";
import {
  addAdminCarrierAction,
  editAdminCarrierAction,
} from "../../redux/Actions";
import { strings, paths } from "../../utils/constants";
import CustomTextField from "../../component/CustomTextField";

export default function AddEditCarrierForm() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { isEditCarrier, editCarrierData, isLoading } = useSelector(
    (state) => state.adminCarrierReducer
  );

  const [carrierNameEn, setCarrierNameEn] = useState(
    isEditCarrier && editCarrierData?.carrier_name != null
      ? editCarrierData?.carrier_name
      : ""
  );
  const [carrierNameFr, setCarrierNameFr] = useState(
    isEditCarrier && editCarrierData?.carrier_name_fr != null
      ? editCarrierData?.carrier_name_fr
      : ""
  );

  const submitUpdateHandler = async (e) => {
    e.preventDefault();
    const specialCharRegex = /^[^a-zA-Z0-9]/;
    
    if (isEmpty(carrierNameEn)) {
      Toast({
        type: "error",
        title: strings.words.ERROR,
        message: strings.admin.error.CARRIER_NAME_ENGLISH_REQUIRED,
      });
    } else if (specialCharRegex.test(carrierNameEn)) {
      Toast({
        type: "error",
        title: strings.words.ERROR,
        message: "Carrier name (English) cannot start with a special character",
      });
    } else if (isEmpty(carrierNameFr)) {
      Toast({
        type: "error",
        title: strings.words.ERROR,
        message: strings.admin.error.CARRIER_NAME_FRENCH_REQUIRED,
      });
    } else if (specialCharRegex.test(carrierNameFr)) {
      Toast({
        type: "error",
        title: strings.words.ERROR,
        message: "Carrier name (French) cannot start with a special character",
      });
    } else {
      if (isEditCarrier) {
        let editAdminCarrierResponse = await dispatch(
          editAdminCarrierAction({
            language: strings.language.EN,
            requestInfo: {
              id: editCarrierData?.id,
              carrier_name: carrierNameEn,
              carrier_name_fr: carrierNameFr,
            },
          })
        );
        if (editAdminCarrierResponse.payload?.success) {
          navigate(paths.adminRoutes.CARRIERS, {
            replace: true,
          });
        }
      } else {
        let addAdminCarrierResponse = await dispatch(
          addAdminCarrierAction({
            language: strings.language.EN,
            requestInfo: {
              carrier_name: carrierNameEn,
              carrier_name_fr: carrierNameFr,
            },
          })
        );
        if (addAdminCarrierResponse.payload?.success) {
          navigate(paths.adminRoutes.CARRIERS, {
            replace: true,
          });
        }
      }
    }
  };

  const cancelHandler = () => {
    navigate(paths.adminRoutes.CARRIERS, {
      replace: true,
    });
  };
  return (
    <>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        mb={5}
      >
        <Typography variant="h4" gutterBottom sx={{ marginLeft: 5 }}>
          {isEditCarrier
            ? strings.general.EDIT_CARRIER
            : strings.general.ADD_NEW_CARRIER}
        </Typography>
      </Stack>
      <form
        style={{
          marginBottom: "5px",
          marginLeft: "50px",
          marginRight: "50px",
        }}
      >
        <CustomTextField
          style={{
            width: "100%",
            marginTop: "5px",
            marginBottom: "5px",
          }}
          type="text"
          label={`${strings.general.CARRIER_NAME_ENGLISH}*`}
          variant="outlined"
          focusColor="#184437"
          value={carrierNameEn}
          autoFocus
          autoComplete="off"
          inputProps={{ maxLength: 150 }}
          onChange={(e) => {
            setCarrierNameEn(e.target.value);
          }}
        />
        <br />
        <CustomTextField
          style={{
            width: "100%",
            marginTop: "10px",
            marginBottom: "5px",
          }}
          type="text"
          label={`${strings.general.CARRIER_NAME_FRENCH}*`}
          variant="outlined"
          focusColor="#184437"
          value={carrierNameFr}
          autoComplete="off"
          inputProps={{ maxLength: 150 }}
          onChange={(e) => {
            setCarrierNameFr(e.target.value);
          }}
        />
        <Stack
          direction={{ xs: "column", sm: "row" }}
          alignItems="start"
          justifyContent="left"
        >
          <Button
            variant="contained"
            color="primary"
            style={{
              backgroundColor: "#184437",
              marginTop: "14px",
              marginRight: "12px",
            }}
            onClick={submitUpdateHandler}
          >
            {isEditCarrier ? strings.words.UPDATE : strings.words.SUBMIT}
          </Button>
          <Button
            variant="contained"
            color="primary"
            style={{ backgroundColor: "#184437", marginTop: "14px" }}
            onClick={cancelHandler}
          >
            {strings.words.CANCEL}
          </Button>
        </Stack>
      </form>
      {isLoading && <ProgressDialog open={isLoading} isAdmin={true} />}
    </>
  );
}
